module.exports = __webpack_public_path__ + "static/media/logo-meta.0e72fe17.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/brand/logo-meta.png
// module id = 1272
// module chunks = 146